import { SERVICE_STATUS } from "@home-health-notify/domain";
import {
  ProgressBar,
  ProgressBarContainer,
  Segment,
} from "./AssignedPatients.style";
import { IActivePatientsProgress, patientServiceColor } from "hhn-commons";
import theme from "../../theme";

const ActivePatientsProgressBar = ({
  progress,
}: {
  progress: IActivePatientsProgress;
}) => {
  const {
    pendingProgress = "0%",
    activeProgress = "0%",
    dischargedProgress = "0%",
  } = progress;

  const pendingWidth = parseFloat(pendingProgress);
  const activeWidth = parseFloat(activeProgress) - pendingWidth;
  const dischargedWidth = parseFloat(dischargedProgress);

  const totalWidth = pendingWidth + activeWidth + dischargedWidth;
  const isEmpty = totalWidth === 0;

  return (
    <ProgressBarContainer data-testid="progress-bar">
      <ProgressBar>
        {isEmpty ? (
          <Segment
            data-testid="empty-progress-bar-segment"
            width={100}
            color={theme.palette.grey["400"]}
          />
        ) : (
          <>
            <Segment
              data-testid="progress-bar-segment"
              width={pendingWidth}
              color={patientServiceColor(SERVICE_STATUS.PENDING)}
            />
            <Segment
              data-testid="progress-bar-segment"
              width={activeWidth}
              color={patientServiceColor(SERVICE_STATUS.ACTIVE)}
            />
            <Segment
              data-testid="progress-bar-segment"
              width={dischargedWidth}
              color={patientServiceColor(SERVICE_STATUS.DISCHARGED)}
            />
          </>
        )}
      </ProgressBar>
    </ProgressBarContainer>
  );
};

export default ActivePatientsProgressBar;
